// import { GET_BALANCE_REQUEST, GET_BALANCE_SUCCESS, GET_BALANCE_FAILUER } from "./types"

import { GET_PROFILE_FAILUER,GET_PROFILE_REQUEST,GET_PROFILE_SUCCESS } from "./types"
const uid= JSON.parse(sessionStorage.getItem('uid'))
const sessionIds= JSON.parse(sessionStorage.getItem('sessionid'))
//reqId
const reqId= JSON.parse(sessionStorage.getItem('reqId'))
const initialState = {
    // loading: false,
    // error: null,
    getprofile: {id:uid ? uid: '', sessionId: sessionIds ? sessionIds:'',requestId:reqId ? reqId : ''}
}
const getprofilereducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PROFILE_REQUEST:
            return {
                ...state,
                // loading: true,
                // error: null,
            }
        case GET_PROFILE_SUCCESS: {

            
            return {
                
                ...state,
                // loading: false,
                getprofile: action.payload
            }
        }
        case GET_PROFILE_FAILUER:
            return {
                ...state,
                // loading: false,
                // error: action.payload.message,
            }

        default:
            return state
    }
}

export default getprofilereducer